import { ENV } from '../../environment';

type Config = {
  accessToken: string;
  assets: Record<string, string>;
  entries: Record<string, string>;
  environment: 'master';
  host: string;
  previewAccessToken: string;
  previewHost: string;
  space: string;
};

const Assets = {
  featuredAssetCarousel: '75AN4SBxxq46nLnJACKwKW',
  historicalAnnualizedReturn: '57O66SBpfQfG3BvuK7g3Xv',
  mapData: '7oiuS1dB26C4wl2yYvovS8',
  pieChart: '7tlzdauKzl8FgUe1JhmpmT',
};

const Entries = {};

const DevEnv: Config = {
  accessToken: 'VXByvAjmRkKcE0qWpPDkLNlSp2RvakvxJYwE0yEmLLw',
  assets: Assets,
  entries: Entries,
  environment: 'master',
  host: 'cdn.contentful.com',
  previewAccessToken: 'jGE1_sDiTgnbDLTKpIfpn1aI2WNFHP5vJZ0HEvI3MvI',
  previewHost: 'preview.contentful.com',
  space: 'cbkr6cekdqlh',
};

const ProdEnv: Config = {
  accessToken: 'VXByvAjmRkKcE0qWpPDkLNlSp2RvakvxJYwE0yEmLLw',
  assets: Assets,
  entries: Entries,
  environment: 'master',
  host: 'cdn.contentful.com',
  previewAccessToken: 'jGE1_sDiTgnbDLTKpIfpn1aI2WNFHP5vJZ0HEvI3MvI',
  previewHost: 'preview.contentful.com',
  space: 'cbkr6cekdqlh',
};

export const config: Config = ENV === 'development' ? DevEnv : ProdEnv;
